<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="fe-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" [message]="isEdit ? 'Cargando crédito…' : 'Preparando formulario…'"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando crédito…' : 'Creando crédito…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="fe-load-error">
        <mat-icon>error</mat-icon>
        <span>{{ isEdit ? 'No se pudo cargar el crédito.' : 'No se pudieron cargar los datos del formulario.' }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body">

      <div class="fe-section" *ngIf="isEmployee">
        <span class="cf-dlg-section__label">Empleado</span>
        <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.employee">
          <app-autocomplete [control]="employeeControl" [config]="{ label: 'Empleado', placeholder: 'Buscar empleado…', options: employees, required: true, autoSelectSingle: true, strict: true }">
          </app-autocomplete>
          <div class="cf-field__error" *ngIf="submitted && errors.employee"><mat-icon>error</mat-icon> {{ errors.employee }}</div>
        </div>
      </div>

      <div class="fe-section" *ngIf="!isEmployee">
        <span class="cf-dlg-section__label">Identificación</span>
        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.duracion">
            <app-autocomplete [control]="duracionControl" [config]="{ label: 'Duración', placeholder: 'Seleccionar duración…', options: termOptions, required: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && errors.duracion"><mat-icon>error</mat-icon> {{ errors.duracion }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.cuentaContableACrear">
            <app-autocomplete [control]="accountControl" [config]="{ label: 'Cuenta contable', placeholder: accountOptions.length ? 'Seleccionar cuenta contable…' : 'Elige antes la duración', options: accountOptions, required: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && errors.cuentaContableACrear"><mat-icon>error</mat-icon> {{ errors.cuentaContableACrear }}</div>
          </div>
        </div>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.descripcion">
          <app-field [control]="descripcionControl" [config]="{ label: 'Descripción', type: 'text', required: true, maxLength: 100 }"></app-field>
          <div class="cf-field__error" *ngIf="submitted && errors.descripcion"><mat-icon>error</mat-icon> {{ errors.descripcion }}</div>
        </div>
      </div>

      <div class="fe-section">
        <span class="cf-dlg-section__label">Plazos</span>
        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.fechaConstitucion">
            <app-date [control]="control('fechaConstitucion')" [config]="{ label: 'Fecha de constitución', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && errors.fechaConstitucion"><mat-icon>error</mat-icon> {{ errors.fechaConstitucion }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.plazo">
            <app-field [control]="control('plazo')" [config]="{ label: 'Plazo (meses)', type: 'number', required: true, inputmode: 'numeric', step: 1, min: 0 }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.plazo"><mat-icon>error</mat-icon> {{ errors.plazo }}</div>
          </div>
        </div>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.fechaFinalizacion">
            <app-date [control]="control('fechaFinalizacion')" [config]="{ label: 'Fecha de finalización', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && errors.fechaFinalizacion"><mat-icon>error</mat-icon> {{ errors.fechaFinalizacion }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.carencia">
            <app-field [control]="control('carencia')" [config]="{ label: 'Carencia (meses)', type: 'number', required: true, inputmode: 'numeric', step: 1, min: 0 }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.carencia"><mat-icon>error</mat-icon> {{ errors.carencia }}</div>
          </div>
        </div>
      </div>

      <div class="fe-section">
        <span class="cf-dlg-section__label">Importes y condiciones</span>
        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.importeInicial">
            <app-field [control]="control('importeInicial')" [config]="{ label: 'Importe inicial', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.importeInicial"><mat-icon>error</mat-icon> {{ errors.importeInicial }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.importePendiente">
            <app-field [control]="control('importePendiente')" [config]="{ label: 'Importe pendiente', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.importePendiente"><mat-icon>error</mat-icon> {{ errors.importePendiente }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.tipoInteres">
            <app-field [control]="control('tipoInteres')" [config]="{ label: 'Tipo de interés', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '%' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.tipoInteres"><mat-icon>error</mat-icon> {{ errors.tipoInteres }}</div>
          </div>
        </div>
      </div>

      <div class="fe-section">
        <span class="cf-dlg-section__label">Liquidaciones y cuenta</span>
        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.tipoLiquidaciones">
            <app-autocomplete [control]="control('tipoLiquidaciones')" [config]="{ label: 'Tipo de liquidaciones', placeholder: 'Seleccionar periodicidad…', options: settlementOptions, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && errors.tipoLiquidaciones"><mat-icon>error</mat-icon> {{ errors.tipoLiquidaciones }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.bankAccount">
            <app-autocomplete [control]="bankAccountControl" [config]="{ label: 'Cuenta de abono', placeholder: 'Seleccionar cuenta…', options: bankAccounts, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && errors.bankAccount"><mat-icon>error</mat-icon> {{ errors.bankAccount }}</div>
          </div>
        </div>
      </div>

      <div class="cf-dlg-mismatch fe-save-error" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear crédito' }}
      </button>
    </div>
  </ng-container>
</div>
